import React from 'react';
import { CircularProgress, Typography, styled } from '@mui/material';

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  flex: 1,
});

const Message = styled(Typography)({
  marginTop: 15,
});

const InsideLoading: React.FC = () => {
  return (
    <Container>
      <CircularProgress color="primary" />
      <Message variant="caption" color="textSecondary">
        carregando...
      </Message>
    </Container>
  );
};

export default InsideLoading;
